import { monthKey, validMonth } from "./firstFridays";
export const FIRST_SATURDAYS_KEY = "theotokos-first-saturdays-v1";
export const firstSaturday = (year, month) => {
  const first = new Date(year, month, 1);
  return new Date(year, month, 1 + (6 - first.getDay() + 7) % 7);
};
export const suggestedSaturdayStart = (today) => {
  const day = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return monthKey(firstSaturday(day.getFullYear(), day.getMonth()) < day ? new Date(day.getFullYear(), day.getMonth() + 1, 1) : day);
};
export const fiveSaturdays = (start) => {
  const [year, month] = start.split("-").map(Number);
  return Array.from({ length: 5 }, (_, index) => {
    const date = firstSaturday(year, month - 1 + index); const id = monthKey(date);
    return { id, date, iso: `${id}-${String(date.getDate()).padStart(2, "0")}` };
  });
};
export const readFirstSaturdays = (today) => {
  const fallback = { start: suggestedSaturdayStart(today), done: [] };
  try {
    const saved = JSON.parse(localStorage.getItem(FIRST_SATURDAYS_KEY));
    if (!saved || !validMonth(saved.start)) return fallback;
    const allowed = fiveSaturdays(saved.start).map((date) => date.id);
    return { start: saved.start, done: [...new Set(Array.isArray(saved.done) ? saved.done.filter((id) => allowed.includes(id)) : [])] };
  } catch { return fallback; }
};